<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.0711 12L4.92893 12" stroke="currentColor" stroke-width="2" />
    <path d="M11.9998 4.92893L11.9998 19.0711" stroke="currentColor" stroke-width="2" />
  </svg>
</template>
